import { Box, Typography } from "@mui/material";
import Header from "../Components/Header";
import xlsx from "json-as-xlsx";
import { useState } from "react";

export default function EBPexport(journal) {
    const [eglise, setEglise] = useState()

    function exportRapport(content) {
        let data = [
          {
            sheet: "SCHEMA",
            columns: [
              { label: "Journal", value: journal },
              { label: "Date", value: row => row.date },
              { label: "N° de pièce", value: row => row.num_piece },
              { label: "Numéro de compte", value: row => row.num_compte },
              { label: "Libellé", value: row => row.libelle },
              { label: "Débit", value: row => row.montant },
              { label: "Crédit", value: row => row.montant },
              { label: "Poste analytique", value: row => row.poste_analytique },
            ],
            content: content,
          },
        ];
      
        let settings = {
          fileName: "RAPPORT-"+eglise?.nom, 
        };
      
        xlsx(data, settings);
    }

    return(
        <Box>
            <Header/>
            <Typography variant="h4" align="center" marginBlock={3}>Module d'export pour EBP</Typography>
        </Box>
    )
}